import { render, staticRenderFns } from "./item.vue?vue&type=template&id=8631a820&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=8631a820&prod&scoped=true&lang=css"
import style1 from "./item.vue?vue&type=style&index=1&id=8631a820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8631a820",
  null
  
)

export default component.exports